module.exports = __webpack_public_path__ + "35ecda59ae6dcf572cb6baf7bf031a9a.png";